// The public supplier form's calls (P2.4). No sign-in: the invite token travels in a header,
// never in a URL, so it does not reach logs or the Referer.

import type { DocSlot } from '../../shared/suppliers/registration';
import { toApiError } from './api';

const HEADER = 'x-invite-token';

export async function registerSend<T>(
  path: 'open' | 'draft' | 'submit',
  token: string,
  body: unknown = {},
): Promise<T> {
  const res = await fetch(`/api/public/register/${path}`, {
    method: 'POST',
    headers: { accept: 'application/json', 'content-type': 'application/json', [HEADER]: token },
    body: JSON.stringify(body),
  });
  if (res.ok) return (await res.json()) as T;
  throw await toApiError(res);
}

export async function registerUpload<T>(slot: DocSlot, token: string, file: File): Promise<T> {
  const res = await fetch(`/api/public/register/file?slot=${slot}`, {
    method: 'POST',
    headers: {
      accept: 'application/json',
      'content-type': 'application/octet-stream',
      'x-file-name': encodeURIComponent(file.name),
      [HEADER]: token,
    },
    body: file,
  });
  if (res.ok) return (await res.json()) as T;
  throw await toApiError(res);
}

/** The token from `#/register?invite=…`, or an empty string. */
export function inviteFromHash(hash: string): string {
  const query = hash.split('?')[1] ?? '';
  return new URLSearchParams(query).get('invite') ?? '';
}
